// extracted by mini-css-extract-plugin
module.exports = {"noGiftButtonHover":"BoxSleeveSelectionBrandRefresh_noGiftButtonHover__Lxyyz"};